import React from 'react';
import Button from '@material-ui/core/Button';
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import ListItem from "@material-ui/core/ListItem";
import _, { omit, pick, round, slice } from 'lodash';
import InputAdornment from "@material-ui/core/InputAdornment";
import { FormControl, FormLabel, FormHelperText } from '@material-ui/core';
import { actions } from "../reducers/app";
import { useDispatch, useSelector } from "react-redux";
import PF from "../_Services/publicFunction";
import { Radio, Paper } from '@material-ui/core';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Qs from "qs";
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useSound from 'use-sound';
import clickdown from '../sounds/clickdown.wav';
import clickup from '../sounds/clickdown.wav';
import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';
import { useSnackbar } from "notistack";


const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 8,
        // borderRadius: 5,
    },
    colorPrimary: {
        //backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        // borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(3),
    },
    button: {
        margin: theme.spacing(1, 1, 0, 0),
    },
    root: {
        color: theme.palette.type === "dark" ? "#1a90ff" : "#3f51b5"
    },
    submitButton: {
        width: "100%", background: '#2E3B55', fontWeight: "bold",
        "&:hover": {
            background: '#fffff',
            // color:'#2E3B55'
        }
    },

}));

const Questionaire70th = props => {
    const [progress, setProgress] = React.useState(0);
    const [numerator, setNumerator] = React.useState(0)
    const [denominator, setDenominator] = React.useState(3)
    const intl = useIntl();

    const initialRender = React.useRef(true);

    const { handleNext, setActiveStep } = props;
    const dispatch = useDispatch();
    const { UserInfo } = useSelector(state => ({
        UserInfo: state.app.UserInfo,
    }));
    const [playActive] = useSound(
        clickdown,
        { volume: 0.25 }
    );
    const [playOn] = useSound(
        clickup,
        { volume: 0.25 }
    );
    const classes = useStyles();
    const [uploadFormat, setUpload] = React.useState({
        0: { BarCodeStr: "", QuestionNo: 70, Category: "填寫前說明", titleNo: "", Title: "說明：本測驗不適用於已被診斷出心血管疾病者或有接受治療者。", SelectTitle: "", Answer: "", Other: "" },
        1: { BarCodeStr: "", QuestionNo: 70, Category: "一、基本資料", titleNo: 1, Title: "你有沒有吸煙：", SelectTitle: "○沒有  ○有吸煙", Answer: "", Other: "" },
        2: { BarCodeStr: "", QuestionNo: 70, Category: "一、基本資料", titleNo: 2, Title: "你有沒有服用高血壓藥物：", SelectTitle: "○沒有  ○有服用高血壓藥物", Answer: "", Other: "" },
        3: { BarCodeStr: "", QuestionNo: 70, Category: "一、基本資料", titleNo: 3, Title: "你有沒有糖尿病史：", SelectTitle: "○沒有  ○有糖尿病史", Answer: "", Other: "" },
        4: { BarCodeStr: "", QuestionNo: 70, Category: "體檢後", titleNo: "", Title: "取得檢測數字[總膽固醇]-[高密度脂蛋白膽固醇]-[收縮壓]，進行風險評估試算，產生[未來10年心血管疾病風險評估表]", SelectTitle: "", Answer: "", Other: "" },
    });
    const [value, setValue] = React.useState('');
    const [done, setDone] = React.useState(false);

    React.useEffect(() => {
        //寫入BarCodeStr
        let obj = Object.values(uploadFormat).reduce((o, { }, index) => {
            o[index] = { BarCodeStr: UserInfo.BarCodeStr }
            return o
        }, {})
        let newitem = _.merge(uploadFormat, obj);
        // console.log(newitem)
        setUpload(prevState => newitem);

    }, []);
    const { enqueueSnackbar } = useSnackbar();

    // React.useEffect(() => {
    //     if (initialRender.current) {
    //         initialRender.current = false;
    //       } else {

    //           setProgress(prev=>prev<99.99?(prev+33.33):prev)
    //       }

    // }, [uploadFormat])
    const validator = () => {
        const form = formRef.current; //參數1
        if (form.checkValidity()) {
            // console.log("全部通過")
            //若驗證通過，刪除錯誤提示
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];

                if (Object.keys(uploadFormat).includes(element.name)) {
                    setUpload(prevState => ({
                        ...prevState,
                        [element.name]: omit(prevState[element.name], ["error", "helperText"])
                    }));
                }

            }
            return true;
        } else {
            // const form = formRef.current;
            // console.log("還沒通過")
            alert(intl.formatMessage({ id: "尚有問題未完成" }));
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
                    console.log(element.validationMessage, element.name);
                    console.log(element.value)
                    // console.log(element.value, element.validationMessage, element.name, element.tagName)
                    if (Object.keys(uploadFormat).includes(element.name)) {
                        setUpload(prevState => ({
                            ...prevState,
                            [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
                        }));
                    }


                } else {//驗證通過，自訂訊息
                    //有在settingObj的
                    console.log("Pass", element.value, element.validationMessage, element.name, element.tagName)
                    if (Object.keys(uploadFormat).includes(element.name)) {
                        setUpload(prevState => ({
                            ...prevState,
                            [element.name]: omit(prevState[element.name], ["error", "helperText"])
                        }));
                    }

                }
            }
            return false;
        }
    }
    const handleSubmit = e => {
        e.preventDefault();
        //setError(!error);
        if (validator()) {

            dispatch(actions.TAB_EDIT({ editing: true, key: 70 }))

            PF.instance({
                method: "post",
                url: PF.url + "/Questionaire/Insert",
                data: Qs.stringify({ list: Object.values(uploadFormat) }),
                headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    console.log(response.data)
                    const { TotalRecord, ErrorMessage } = response.data
                    if (TotalRecord <= 0) {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #170 企業健檢")
                        enqueueSnackbar(intl.formatMessage({ id: "update fail" }), { variant: "error", style: { whiteSpace: 'pre-line' } });
                    } else {
                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                        setDone(true);
                        enqueueSnackbar(intl.formatMessage({ id: "update success" }), { variant: "success", style: { whiteSpace: 'pre-line' } });
                    }
                })
        }
    }

    const handleRadioChange = e => {
        // e.prevetDefault();
        if (!done) {
            const { name, value } = e.target;

            // console.log(name, value)
            // setValue(value);
            setUpload(prevState => ({
                ...prevState,
                [name]: { ...prevState[name], BarCodeStr: UserInfo.BarCodeStr, Answer: value }
            }))
            if (uploadFormat[name].Answer === "") {
                //setProgress(prev => prev < 99.99 ? (prev + 33.33) : prev)
                setNumerator(prev => prev + 1)
            }
        }
    }
    const formRef = React.createRef();


    return (
        <Paper>
            <h1 style={{ textAlign: "center" }}><FormattedMessage id={"十年心血管風險評估"} /></h1>
            <form onSubmit={handleSubmit} ref={formRef} noValidate>
                <fieldset>
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"填寫前說明"} /></Typography></legend>
                    <Typography><FormattedMessage id={uploadFormat[0].Title} /></Typography>
                </fieldset>
                <fieldset>
                    <legend align="left"><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"基本資料"} /></Typography></legend>
                    {Object.values(uploadFormat).slice(1, 4).map((item, index) => {
                        return (
                            <FormControl component="fieldset" error={item.error} required className={classes.formControl} key={index}>
                                <FormLabel component="legend" className={classes.root}>{item.titleNo + "."}<FormattedMessage id={item.Title} /></FormLabel>
                                <RadioGroup name={item.titleNo} value={item.Answer} onChange={handleRadioChange} style={{ display: "block" }}>
                                    {item.SelectTitle.replaceAll("○", "").split("  ").map(pro => {
                                        return (
                                            <FormControlLabel value={pro} control={<Radio color="primary" required />} label={<FormattedMessage id={pro} />} onMouseDown={() => { playActive() }} />)
                                    })}
                                </RadioGroup>
                                <FormHelperText>{item.error ? <FormattedMessage id={item.helperText} /> : null}</FormHelperText>
                            </FormControl>)
                    })}
                </fieldset>
                <fieldset>
                    <legend align="left"><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"體檢後"} /></Typography></legend>
                    <Typography><FormattedMessage id={uploadFormat[4].Title} /></Typography>
                </fieldset>
                <div style={{ width: '100%', bottom: !done ? "36px" : "0px", position: "fixed", }}>
                    <BorderLinearProgress variant="determinate" value={(numerator / denominator) * 100} />
                </div>
                <br /><br />
                {!done ? (<div style={{ top: 'auto', bottom: 0, position: "fixed", width: "100%" }}>
                    <Button variant="contained" color="primary" type="submit" onClick={handleSubmit} className={classes.submitButton}><FormattedMessage id={"app.Submit"} /></Button>
                </div>) : null}
            </form>
        </Paper>
    )



}

export default Questionaire70th
